<template>
 <div>
	 <div class="footer">
		 <div class="contact_us w">
			 <div class="top_footer">
			 	<dl>
			 	  <dt>泵产品</dt>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/verderflex/" target="_blank">软管蠕动泵</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/verderair-double-diaphragm-pumps/" target="_blank">气动双隔膜泵</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/packo-hygienic-centrifugal-pumps/" target="_blank">离心泵</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/pumps-by-principle/%E5%8A%A0%E8%8D%AF%E6%B3%B5/" target="_blank">加药泵</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/verdergear/" target="_blank">齿轮泵</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/jabsco-hygienic-lobe-pumps/" target="_blank">卫生泵</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/verderflex-oem-%E6%B3%B5%E5%A4%B4/"target="_blank">OEM蠕动泵</a>
			 	  </dd>
			 	</dl>
			 	<dl>
			 	  <dt>行业</dt>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/automotive/"target="_blank">Automotive</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/pumps-for-the-chemical-industry/"target="_blank">化工</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/pumps-for-the-pharmaceutical-and-cosmetic-industry/"target="_blank">医药和化妆品</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/dairy/"target="_blank">Dairy</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/pumps-for-the-food-and-beverage-industry/"target="_blank">食品和饮料</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/industrial-positive-displacement-pumps/"target="_blank">制造业及相关技术</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/paper-pulp-printing-packaging/"target="_blank">Paper, Pulp, Printing & Packaging</a>
			 	  </dd>
				  <dd>
				    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/pumps-for-the-oil-and-gas-industry/"target="_blank">油和天然气</a>
				  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/%E5%8E%9F%E8%AE%BE%E5%A4%87%E5%88%B6%E9%80%A0%E5%95%86/"target="_blank">原设备制造商</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/pumps-for-the-waste-water-treatment-industry/"target="_blank">(污水）水处理</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/%E9%87%87%E7%9F%BF%E4%B8%9A/"target="_blank">采矿业</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/transport/"target="_blank">Transport</a>
			 	  </dd>
			 	  <dd>
			 	    <a href="http://www.verder.cn/cn/zh/%E8%A1%8C%E4%B8%9A/pumps-for-the-pool-and-spa/"target="_blank">Pool & Spa</a>
			 	  </dd>
			 	</dl>
			 	<dl>
			 	  <dt>联系我们</dt>
			 	  <dd>
			 	    <a href="#">弗尔德（上海）仪器设备有限公司 上海浦东新区康威路739弄15号楼</a>
			 	  </dd>
			 	  <!-- <dd>
					<i class="iconfont iconWeb-kefudianhua" style="color: #B0B0B0;"></i>
			 	    <a href="#">021-33932950 或 18301997215</a>
			 	  </dd> -->
			 	  <dd>
					<i class="iconfont iconWeb-youxiang" style="color: #B0B0B0;"></i>
			 	    <a href="#">info@verder.com</a>
			 	  </dd>
			 	</dl>
			 	<div class="big_box">
			 					 <div class="qr_Code">
			 					 	<div class="qr_Code_img"><img style="width: 100%;" src="../assets/img/footer/QRcode.png"/></div>
			 					 </div>
			 					 <div class="follow">关注弗尔德公众号</div>
			 	</div>
			 </div>
			 <div class="bottom_footer" style="-webkit-user-select: none;">
				 <div class="record_Number"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #B0B0B0;">沪ICP备17012933号-10</a></div>
				 <div class="record_Number"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #B0B0B0;">沪ICP备17012933号-10</a></div>
			 </div>
		 </div>
	 </div>
 </div>
</template>

<script>
  import '@/assets/sass/footer.css'
  export default {
    name: 'footers',
    data() {
      return {

      }
    },
    mounted() {


    },
    methods: {

    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/footers.vue